module.exports = __webpack_public_path__ + "static/media/txn.d5831ec6.svg";